import {TypeDiffusionEnum} from "@resources/resources";

export class TypeDiffusionEnums {

  private static _tag: TypeDiffusionEnum = 'TAG';
  private static _tous: TypeDiffusionEnum = 'TOUS';

  static TAG = new TypeDiffusionEnums(TypeDiffusionEnums._tag);
  static TOUS = new TypeDiffusionEnums(TypeDiffusionEnums._tous);

  private static _values = [TypeDiffusionEnums.TAG.value(), TypeDiffusionEnums.TOUS.value()];

  constructor(public str: TypeDiffusionEnum) {
  }

  value(): TypeDiffusionEnum {
    return this.str;
  }

  static values(): Array<TypeDiffusionEnum> {
    return this._values;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/common/enum/typediffusion.enum.ts